// removed by extract-text-webpack-plugin
module.exports = {"empty-events":"_2HYafLXsf undefined _2AKkwhco3 _1K-PUKdV4 _2CHR8eNXb aokgWzHRc _1OqJ1vEYi _3X1wVezBb _2tUH4Ega5","description":"_1HUpwRDpD _1yJuXbiru _1N1LPNKhM _1yThnDgzj _1BE2U7F8v _2AKkwhco3 _2tvY6e7Hw _1gaUFCwDT _1JAgybqD3 _3c-m5_Qq2","link":"_1JyQSRdkw _2l0xl0HVf _1jY4uEptA"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/empty-events/empty-events.css
 ** module id = 2099
 ** module chunks = 0
 **/